import React from 'react';
import { ParticipantHubLayout } from './ParticipantHubLayout';
import { motion } from 'framer-motion';
import { CalendarIcon, MapPinIcon, ClockIcon, PlayIcon, FileTextIcon, TargetIcon, SparklesIcon, CheckCircle2Icon, ArrowRightIcon, MessageSquareIcon } from 'lucide-react';
export function HubOverviewPage() {
  return <ParticipantHubLayout data-id="element-4639">
      <div className="p-6 lg:p-8 max-w-6xl mx-auto space-y-8" data-id="element-4640">
        {/* Hero Card */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="bg-[#0B1B3B] rounded-2xl overflow-hidden relative shadow-lg" data-id="element-4641">
          {/* Subtle background pattern */}
          <div className="absolute inset-0 opacity-20" data-id="element-4642">
            <div className="absolute top-0 right-0 w-[800px] h-[800px] bg-amber-500/20 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3" data-id="element-4643" />
            <div className="absolute bottom-0 left-0 w-[600px] h-[600px] bg-teal-500/20 rounded-full blur-3xl translate-y-1/3 -translate-x-1/4" data-id="element-4644" />
          </div>

          <div className="relative z-10 p-8 lg:p-12 flex flex-col lg:flex-row gap-8 lg:items-center justify-between" data-id="element-4645">
            <div className="max-w-2xl" data-id="element-4646">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/10 border border-white/20 text-amber-400 text-xs font-medium mb-6" data-id="element-4647">
                <SparklesIcon className="w-3.5 h-3.5" data-id="element-4648" />
                Personalized Intelligence
              </div>
              <h1 className="font-serif-display text-5xl lg:text-6xl text-white mb-4" data-id="element-4649">
                Welcome back, Sarah.
              </h1>
              <p className="text-lg text-slate-300 mb-8 leading-relaxed" data-id="element-4650">
                Your digital guidance layer for the Finova Capital Executive
                Summit. Everything you need to prepare, engage, and act.
              </p>

              <div className="flex flex-wrap items-center gap-4 text-sm text-slate-300" data-id="element-4651">
                <div className="flex items-center gap-2" data-id="element-4652">
                  <CalendarIcon className="w-4 h-4 text-amber-500" data-id="element-4653" />
                  Oct 12 - 15, 2026
                </div>
                <div className="flex items-center gap-2" data-id="element-4654">
                  <MapPinIcon className="w-4 h-4 text-amber-500" data-id="element-4655" />
                  Moon Palace Cancún
                </div>
                <div className="flex items-center gap-2 px-3 py-1 rounded-md bg-white/10 border border-white/10" data-id="element-4656">
                  <ClockIcon className="w-4 h-4 text-amber-500" data-id="element-4657" />
                  14 Days Until Arrival
                </div>
              </div>
            </div>

            {/* Hub Completion Card */}
            <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-xl p-6 w-full lg:w-72 shrink-0" data-id="element-4658">
              <div className="text-sm text-slate-300 mb-2" data-id="element-4659">Hub Completion</div>
              <div className="flex items-baseline gap-2 mb-4" data-id="element-4660">
                <span className="font-serif-display text-5xl text-amber-500" data-id="element-4661">
                  22<span className="text-3xl" data-id="element-4662">%</span>
                </span>
                <span className="text-sm text-slate-400" data-id="element-4663">overall</span>
              </div>
              <div className="h-2 bg-white/10 rounded-full overflow-hidden mb-4" data-id="element-4664">
                <div className="h-full bg-amber-500 rounded-full" style={{
                width: '22%'
              }} data-id="element-4665" />
              </div>
              <div className="text-sm text-white font-medium" data-id="element-4666">
                Next: Complete Arrival Briefing
              </div>
            </div>
          </div>
        </motion.div>

        {/* Action Row */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="flex flex-wrap gap-4" data-id="element-4667">
          <button className="flex items-center gap-2 px-6 py-3 bg-[#0B1B3B] text-white rounded-xl font-medium hover:bg-[#0B1B3B]/90 transition-colors shadow-sm" data-id="element-4668">
            <PlayIcon className="w-4 h-4" data-id="element-4669" />
            Resume Flight Pack
          </button>
          <button className="flex items-center gap-2 px-6 py-3 bg-white border border-slate-200 text-slate-700 rounded-xl font-medium hover:bg-slate-50 transition-colors shadow-sm" data-id="element-4670">
            <FileTextIcon className="w-4 h-4" data-id="element-4671" />
            View Arrival Briefing
          </button>
          <button className="flex items-center gap-2 px-6 py-3 bg-white border border-slate-200 text-slate-700 rounded-xl font-medium hover:bg-slate-50 transition-colors shadow-sm" data-id="element-4672">
            <TargetIcon className="w-4 h-4" data-id="element-4673" />
            Open Action Plan
          </button>
        </motion.div>

        {/* Personalized Intelligence */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} className="bg-amber-50 rounded-2xl border border-amber-100 p-6 lg:p-8 flex gap-6 items-start" data-id="element-4674">
          <div className="w-12 h-12 rounded-full bg-white shadow-sm flex items-center justify-center shrink-0" data-id="element-4675">
            <SparklesIcon className="w-6 h-6 text-amber-500" data-id="element-4676" />
          </div>
          <div data-id="element-4677">
            <h2 className="font-serif-display text-2xl text-slate-900 mb-2" data-id="element-4678">
              Your Personalized Intelligence
            </h2>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-4679">
              Based on your pre-retreat diagnostic, we recommend focusing on the{' '}
              <strong className="font-semibold text-slate-900" data-id="element-4680">
                AI Integration Frameworks
              </strong>{' '}
              in the Knowledge Studio. Your responses indicate a strong interest
              in operationalizing AI within your specific business unit.
            </p>
            <button className="text-amber-700 font-semibold text-sm flex items-center gap-1 hover:text-amber-800 transition-colors" data-id="element-4681">
              Explore Recommended Frameworks
              <ArrowRightIcon className="w-4 h-4" data-id="element-4682" />
            </button>
          </div>
        </motion.div>

        {/* Journey Timeline */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3
      }} className="bg-white rounded-2xl border border-slate-200 p-6 lg:p-8 shadow-sm" data-id="element-4683">
          <h3 className="font-serif-display text-2xl text-slate-900 mb-8" data-id="element-4684">
            Your Journey
          </h3>
          <div className="relative" data-id="element-4685">
            <div className="absolute top-5 left-0 right-0 h-0.5 bg-slate-100" data-id="element-4686" />
            <div className="absolute top-5 left-0 w-1/4 h-0.5 bg-amber-500" data-id="element-4687" />

            <div className="grid grid-cols-4 gap-4 relative z-10" data-id="element-4688">
              {[{
              phase: 'Prepare',
              status: 'current',
              desc: 'Flight Pack & Diagnostics'
            }, {
              phase: 'Arrive',
              status: 'pending',
              desc: 'Briefing & Welcome'
            }, {
              phase: 'Engage',
              status: 'pending',
              desc: 'Live Sessions & Workshops'
            }, {
              phase: 'Act',
              status: 'pending',
              desc: 'Integration & Action Plan'
            }].map((step, i) => <div key={i} className="flex flex-col items-center text-center" data-id="element-4689">
                  <div className={`w-10 h-10 rounded-full flex items-center justify-center mb-3 border-2 bg-white ${step.status === 'current' ? 'border-amber-500 text-amber-500' : step.status === 'done' ? 'border-amber-500 bg-amber-500 text-white' : 'border-slate-200 text-slate-300'}`} data-id="element-4690">
                    {step.status === 'done' ? <CheckCircle2Icon className="w-5 h-5" data-id="element-4691" /> : <span className="text-sm font-bold" data-id="element-4692">{i + 1}</span>}
                  </div>
                  <div className={`font-bold text-sm mb-1 ${step.status === 'current' ? 'text-slate-900' : 'text-slate-500'}`} data-id="element-4693">
                    {step.phase}
                  </div>
                  <div className="text-xs text-slate-400 hidden md:block px-2" data-id="element-4694">
                    {step.desc}
                  </div>
                </div>)}
            </div>
          </div>
        </motion.div>

        {/* 2-Col Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-4695">
          {/* Your Cohort */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4
        }} className="bg-white rounded-2xl border border-slate-200 p-6 lg:p-8 shadow-sm" data-id="element-4696">
            <div className="flex items-center justify-between mb-6" data-id="element-4697">
              <h3 className="font-serif-display text-2xl text-slate-900" data-id="element-4698">
                Your Cohort
              </h3>
              <button className="text-sm text-amber-600 font-medium hover:text-amber-700" data-id="element-4699">
                View All 32
              </button>
            </div>
            <div className="space-y-4" data-id="element-4700">
              {[{
              name: 'Marcus Chen',
              role: 'VP Engineering',
              hook: 'Ask about: Q3 Platform Migration',
              initials: 'MC',
              color: 'bg-blue-100 text-blue-700'
            }, {
              name: 'Elena Rodriguez',
              role: 'Head of Product',
              hook: 'Ask about: New AI Features',
              initials: 'ER',
              color: 'bg-emerald-100 text-emerald-700'
            }, {
              name: 'David Kim',
              role: 'Chief Strategy Officer',
              hook: 'Ask about: M&A Pipeline',
              initials: 'DK',
              color: 'bg-purple-100 text-purple-700'
            }].map((person, i) => <div key={i} className="flex items-center gap-4 p-3 rounded-xl hover:bg-slate-50 transition-colors border border-transparent hover:border-slate-100" data-id="element-4701">
                  <div className={`w-10 h-10 rounded-full flex items-center justify-center text-sm font-bold shrink-0 ${person.color}`} data-id="element-4702">
                    {person.initials}
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-4703">
                    <div className="font-bold text-sm text-slate-900 truncate" data-id="element-4704">
                      {person.name}
                    </div>
                    <div className="text-xs text-slate-500 truncate" data-id="element-4705">
                      {person.role}
                    </div>
                  </div>
                  <button className="p-2 text-slate-400 hover:text-amber-600 transition-colors" title={person.hook} data-id="element-4706">
                    <MessageSquareIcon className="w-4 h-4" data-id="element-4707" />
                  </button>
                </div>)}
            </div>
          </motion.div>

          {/* What's New */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.5
        }} className="bg-white rounded-2xl border border-slate-200 p-6 lg:p-8 shadow-sm" data-id="element-4708">
            <h3 className="font-serif-display text-2xl text-slate-900 mb-6" data-id="element-4709">
              What's New
            </h3>
            <div className="space-y-6" data-id="element-4710">
              {[{
              title: 'Welcome Dinner Venue Updated',
              time: '2 hours ago',
              desc: 'The welcome dinner on Day 1 has been moved to the Ocean Terrace.',
              icon: MapPinIcon
            }, {
              title: 'New Pre-Read Available',
              time: 'Yesterday',
              desc: '"The Future of Autonomous Agents" has been added to your Knowledge Studio.',
              icon: BookOpenIcon
            }, {
              title: 'Diagnostic Deadline Approaching',
              time: '2 days ago',
              desc: 'Please complete your pre-retreat diagnostic by Friday.',
              icon: TargetIcon
            }].map((item, i) => <div key={i} className="flex gap-4" data-id="element-4711">
                  <div className="w-8 h-8 rounded-full bg-slate-50 border border-slate-100 flex items-center justify-center shrink-0 mt-1" data-id="element-4712">
                    <item.icon className="w-4 h-4 text-slate-400" data-id="element-4713" />
                  </div>
                  <div data-id="element-4714">
                    <div className="flex items-baseline gap-2 mb-1" data-id="element-4715">
                      <div className="font-bold text-sm text-slate-900" data-id="element-4716">
                        {item.title}
                      </div>
                      <div className="text-xs text-slate-400" data-id="element-4717">{item.time}</div>
                    </div>
                    <p className="text-sm text-slate-600" data-id="element-4718">{item.desc}</p>
                  </div>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </ParticipantHubLayout>;
}